import React from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  Link,
  makeStyles,
  SvgIcon
} from '@material-ui/core';
import { Menu as MenuIcon } from 'react-feather';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { THEMES } from 'src/constants';
import { useTranslation } from 'react-i18next';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    ...(theme.name === THEMES.TEROTECH
      ? {
          boxShadow: 'none',
          backgroundColor: theme.palette.primary.main
        }
      : {}),
    ...(theme.name === THEMES.ONE_DARK
      ? {
          backgroundColor: theme.palette.background.default
        }
      : {})
  },
  appBar: {
    top: 'auto',
    bottom: 0
  },
  toolbar: {
    minHeight: 64,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  speedDial: {
    position: 'absolute',
    '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
      bottom: theme.spacing(2),
      right: theme.spacing(2)
    },
    '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
      top: theme.spacing(2),
      left: theme.spacing(2)
    }
  }
}));

const BottomBar = ({ className, onMobileNavOpen, ...rest }) => {
  const classes = useStyles();
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };
  const [direction, setDirection] = React.useState('up');
  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const navigateEwo = () => {
    history.push('/app/tablet/homeTablet/newEwo?view=tablet');
  };

  const navigateTag = () => {
    history.push('/app/tablet/homeTablet/newTag?view=tablet');
  };

  const docStyle={display: 'flex', justifyContent: 'center', alignItems: 'center'};

  const toolBarStyle={display: 'flex', justifyContent: 'center'}
  return (
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, className)}
      {...rest}
    >
      <Toolbar className={classes.toolbar} style={toolBarStyle}>

      <div className={classes.div} style={docStyle}>
            <Link

            className={classes.link}
            color="textSecondary"
            component={RouterLink}

            to="/app/tablet/homeTablet"

            underline="none"

            variant="body2"
            >
            Back to HOME
          </Link>
        </div>
        <div className={classes.exampleWrapper}>
          <SpeedDial
            ariaLabel="SpeedDial example"
            className={classes.speedDial}
            hidden={hidden}
            icon={<SpeedDialIcon />}
            onClose={handleClose}
            onOpen={handleOpen}
            open={open}
            direction={direction}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem button>
                  <ListItemText primary="TAG" onClick={navigateTag} />
                </ListItem>
                {/* <ListItem button>
                  <ListItemText primary="EWO" onClick={navigateEwo} />
                </ListItem> */}
              </List>
            </Collapse>
          </SpeedDial>
        </div>
      </Toolbar>
    </AppBar>
  );
};

BottomBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

BottomBar.defaultProps = {
  onMobileNavOpen: () => {}
};

export default BottomBar;
